import { BasePreviewViewStore } from 'core/stores';
import { applicationContext,toDate } from 'core/utils';
import { ProductHistoryService } from 'application/product/services';

@applicationContext
class ProductHistoryPreviewViewStore extends BasePreviewViewStore {
    constructor(rootStore) {
        const id = rootStore.routerStore.routerState.params.id;
        const previousId = rootStore.routerStore.routerState.params.previousId;
        const service = new ProductHistoryService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'product-history-preview',
            id: id,
            authorization: 'productCatalogSection.read',
            actions: () => {
                return {
                    get: async (id) => {
                        const previousResponse = await service.get(previousId, { embed: 'ProductNewValue' });
                        this.previousItem = {...previousResponse.data.productNewValue, dateCreated: previousResponse.data.dateCreated && toDate(previousResponse.data.dateCreated, true)};
                        const response = await service.get(id, { embed: 'ProductNewValue,CoreUser' });
                        return {...response.data.productNewValue, dateCreated: response.data.dateCreated && toDate(response.data.dateCreated, true), coreUserName: response.data.coreUser && `${response.data.coreUser.lastName}, ${response.data.coreUser.firstName}`, date: response.data.dateCreated && toDate(response.data.dateCreated),};
                    }
                }
            },
        });
    }
}

export default ProductHistoryPreviewViewStore;
